module.exports = __webpack_public_path__ + "static/media/onboarding-3.dd677d9a.png";